const getUi = state => state.ui;

export default getUi;
